import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

import './bulletinTitle.scss';

const BulletinTitle: React.FC<{}> = () => {
    const { bulletins } = useLocalization();
    return (
        <div className='bulletins-header'>
            <div className='bulletins-title'>
                {bulletins.LABEL_BULLETINS_TITLE}
            </div>
            {/* // Temporarily hiding View all bulletins & View bulletin archive – enable when feature is ready */}
            {/* <div className='bulletins-archive-link large-show'>
                <a>{bulletins.LABEL_BULLETINS_ALL}</a>
            </div>
            <div className='bulletins-archive-link small-show'>
                <a>{bulletins.LABEL_BULLETINS_ARCHIVE}</a>
            </div> */}
        </div>
    );
};

export default BulletinTitle;
